import {
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
} from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { Profile } from "src/app/Models/profile.interface";
import { Question } from "src/app/Models/question.interface";
import { LanguageSwitchService } from "src/app/Services/LanguageSwitch/language-switch.service";
import { UserManager } from "src/app/Services/UserManager/user-manager";
import { QuestionComponent } from "../question/question.component";
import { ScrollService } from "src/app/Services/ScrollManager/scroll.service";

@Component({
  selector: "app-lesson-page",
  templateUrl: "./lesson-page.component.html",
  styleUrls: ["./lesson-page.component.css"],
})
export class LessonPageComponent implements OnInit, OnDestroy {
  constructor(
    private afs: AngularFirestore,
    private ls: LanguageSwitchService,
    private um: UserManager,
    private route: ActivatedRoute,
    private scroll: ScrollService
  ) {}
  config;
  lessonId;
  lang;
  lesson;
  questions = [];
  current = null;
  profile: Profile;
  leaving = new Subject();

  @ViewChild(QuestionComponent)
  questionElements: QueryList<QuestionComponent>;

  ngOnDestroy(): void {
    this.leaving.next();
    this.leaving.complete();
  }

  scrollToQuestion() {
    this.scroll.scrollToElement(`#dots`);
  }

  ngOnInit(): void {
    this.lessonId = this.route.snapshot.paramMap.get("id");
    this.lang = this.um.profile?.preferences?.language.code ?? "en";
    this.um.profileSubject.takeUntil(this.leaving).subscribe({
      next: (profile) => {
        this.profile = profile;
      },
    });
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
        this.getLesson();
      },
    });
  }

  goto = (questionID: number) => {
    if (this.questions?.[questionID]) {
      this.current = this.questions[questionID];
    }
  };

  isCorrect(questionID: number) {
    // since an item isn't rendered until its
    // selected, questionElements is empty.
    console.log(this.questionElements);
    return true;
    let q = this.questionElements.find((question) => {
      return questionID === +question.question.questionID;
    });
    if (q) {
      return q.allCorrect;
    } else {
      return false;
    }
  }

  trackBy(index, item) {
    return item.questionID;
  }

  next = () => {
    if (this.questions?.[this.current?.questionID + 1]) {
      this.current = this.questions[this.current.questionID + 1];
    } else {
      alert("next Lesson");
    }
  };

  previous = () => {
    if (this.questions?.[this.current?.questionID - 1]) {
      this.current = this.questions[this.current.questionID - 1];
    } else {
      alert("Do nothing");
    }
  };

  getNextButtonTitle = () => {
    return "Next";
  };

  getLesson = () => {
    this.afs
      .collection("Languages")
      .doc(this.lang)
      .collection("Lessons")
      .doc(this.lessonId)
      .get()
      .take(1)
      .subscribe({
        next: (doc) => {
          this.lesson = doc.data();
          this.questions = Object.values<Question>(this.lesson).sort(
            (a, b) => Number(a.questionID) - Number(b.questionID)
          );
          this.current = this.questions[0];
        },
      });
  };
}
